import React from 'react';

// ── SHARED MINI-GAME TYPES ───────────────────────────────────────────────────
//
// Each streak-reward mini-game implements this contract. StreakReward.tsx owns
// the intro/done shell, scoring display, and theming; a game only renders its
// play area and calls onEnd({ score, noun }) when it finishes.

export interface GameTheme {
  bg: string;
  card: string;
  accent: string;
  btn: string;
  text: string;
  light: string;
}

export interface GameResult {
  score: number;
  noun: string; // e.g. "stars" — used in the done screen: "You popped 7 stars!"
}

export interface GameProps {
  theme: GameTheme;
  isKid: boolean;
  onEnd: (result: GameResult) => void;
}

export interface GameDef {
  id: string;
  title: string;
  emoji: string;
  instructions: string; // shown on the intro screen
  verb: string; // intro CTA flavor, e.g. "Pop", "Whack", "Match", "Catch"
  Component: React.FC<GameProps>;
}

// Shared play-area styling so every game has a consistent frame.
export function playAreaStyle(theme: GameTheme): React.CSSProperties {
  return {
    position: 'relative',
    width: '100%',
    height: '52vh',
    maxHeight: '440px',
    background: `linear-gradient(160deg, ${theme.bg}, ${theme.light}55)`,
    border: `2px dashed ${theme.light}`,
    borderRadius: '16px',
    overflow: 'hidden',
    marginTop: '12px',
    touchAction: 'none',
  };
}
